/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
  email: '',
  name: '',
  token: '',
  tries: 0,
  isLicense: true,
  bestScore: 0,
};

const getters = {
  email: state => state.email,
  name: state => state.name,
  token: state => state.token,
  tries: state => state.tries,
  isLicense: state => state.isLicense,
  bestScore: state => state.bestScore,
};

const mutations = {
  set_email(state, data) {
    state.email = data;
  },
  set_name(state, data) {
    state.name = data;
  },
  set_token(state, data) {
    state.token = data;
  },
  set_tries(state, data) {
    state.tries = data;
  },
  set_isLicense(state, data) {
    state.isLicense = data;
  },
  set_bestScore(state, data) {
    state.bestScore = data;
  },
};

const store = new Vuex.Store({
  state,
  getters,
  mutations,
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js